import React from 'react';

export const NotificationsIcon = props => {
  return (
    <svg
      viewBox="0 0 18 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      stroke="black"
    >
      <path
        d="M6 12.5L7.7175 14.2175C7.8855 14.3867 8.0853 14.5209 8.30543 14.6126C8.52555 14.7042 8.76157 14.7514 9 14.7514C9.23843 14.7514 9.47445 14.7042 9.69457 14.6126C9.9147 14.5209 10.1145 14.3867 10.2825 14.2175L12 12.5H13.5C14.2957 12.5 15.0587 12.184 15.6213 11.6214C16.1839 11.0587 16.5 10.2957 16.5 9.5V4.25C16.5 3.45435 16.1839 2.69133 15.6213 2.12872C15.0587 1.56612 14.2957 1.25 13.5 1.25H4.5C3.70435 1.25 2.94129 1.56612 2.37868 2.12872C1.81607 2.69133 1.5 3.45435 1.5 4.25V9.5C1.5 10.2957 1.81607 11.0587 2.37868 11.6214C2.94129 12.184 3.70435 12.5 4.5 12.5H6Z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.75 5.75H5.25"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.75 8H5.25"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export const MyEquipmentIcon = props => {
  return (
    <svg
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      stroke="black"
    >
      <path
        d="M9.91983 8.28855C9.80852 8.17717 9.65747 8.11462 9.50001 8.11462C9.34255 8.11462 9.1915 8.17717 9.08019 8.28855L7.101 10.2677C6.86913 10.4996 6.86913 10.8755 7.101 11.1074C7.33287 11.3392 7.70881 11.3392 7.94066 11.1074L8.90626 10.1418V13.4584C8.90626 13.7863 9.1721 14.0521 9.50001 14.0521C9.82792 14.0521 10.0938 13.7863 10.0938 13.4584V10.1418L11.0594 11.1074C11.2912 11.3392 11.6671 11.3392 11.899 11.1074C12.1309 10.8755 12.1309 10.4996 11.899 10.2677L9.91983 8.28855Z"
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.54545 0.989624H9.45457C7.62711 0.989616 6.19495 0.989608 5.07753 1.13984C3.93378 1.29362 3.03126 1.61451 2.32287 2.3229C1.61448 3.03129 1.29359 3.93381 1.13981 5.07756C0.989578 6.19498 0.989586 7.62713 0.989594 9.4546V9.50004H0.998239C0.989594 9.95826 0.989594 10.4737 0.989594 11.0568V11.11C0.989594 12.1959 0.989586 13.0473 1.04549 13.7316C1.10242 14.4283 1.22027 15.0039 1.48574 15.5249C1.92217 16.3815 2.61854 17.0779 3.47508 17.5143C3.9961 17.7798 4.57173 17.8976 5.2685 17.9546C5.95277 18.0105 6.80414 18.0105 7.89005 18.0105H11.1099C12.1959 18.0105 13.0472 18.0105 13.7315 17.9546C14.4283 17.8976 15.0039 17.7798 15.5249 17.5143C16.3815 17.0779 17.0778 16.3815 17.5143 15.5249C17.7797 15.0039 17.8976 14.4283 17.9545 13.7316C18.0104 13.0473 18.0104 12.1959 18.0104 11.11V11.0568C18.0104 10.4739 18.0104 9.95818 18.0018 9.50004H18.0104V9.4546C18.0104 7.62714 18.0104 6.19498 17.8602 5.07756C17.7064 3.93381 17.3856 3.03129 16.6772 2.3229C15.9688 1.61451 15.0662 1.29362 13.9225 1.13984C12.8051 0.989608 11.3729 0.989616 9.54545 0.989624ZM3.47508 4.65244C3.02913 4.87965 2.62661 5.17733 2.28157 5.5314C2.29218 5.42996 2.30386 5.33147 2.31672 5.23579C2.45279 4.22372 2.71158 3.61356 3.16256 3.16259C3.61353 2.71161 4.22369 2.45282 5.23576 2.31675C6.26491 2.17838 7.61724 2.17712 9.50001 2.17712C11.3828 2.17712 12.7351 2.17838 13.7642 2.31675C14.7763 2.45282 15.3864 2.71161 15.8375 3.16259C16.2885 3.61356 16.5473 4.22372 16.6833 5.23579C16.6962 5.33148 16.7078 5.42996 16.7184 5.5314C16.3734 5.17734 15.9709 4.87965 15.5249 4.65244C15.0039 4.38697 14.4283 4.26912 13.7315 4.21219C13.0472 4.15628 12.1959 4.15629 11.1099 4.15629H7.89012C6.80416 4.15629 5.95278 4.15628 5.2685 4.21219C4.57173 4.26912 3.9961 4.38697 3.47508 4.65244ZM4.01419 5.71051C4.3399 5.54455 4.74186 5.44668 5.3652 5.39575C5.99548 5.34425 6.79844 5.34379 7.91668 5.34379H11.0833C12.2016 5.34379 13.0046 5.34425 13.6348 5.39575C14.2582 5.44668 14.6601 5.54455 14.9859 5.71051C15.6189 6.03308 16.1336 6.5478 16.4562 7.18088C16.6222 7.5066 16.72 7.90855 16.771 8.53191C16.8225 9.16216 16.8229 9.96514 16.8229 11.0834C16.8229 12.2016 16.8225 13.0046 16.771 13.6348C16.72 14.2582 16.6222 14.6601 16.4562 14.9859C16.1336 15.6189 15.6189 16.1337 14.9859 16.4563C14.6601 16.6222 14.2582 16.72 13.6348 16.771C13.0046 16.8225 12.2016 16.823 11.0833 16.823H7.91668C6.79844 16.823 5.99548 16.8225 5.3652 16.771C4.74186 16.72 4.3399 16.6222 4.01419 16.4563C3.3811 16.1337 2.86638 15.6189 2.54381 14.9859C2.37785 14.6601 2.27998 14.2582 2.22905 13.6348C2.17755 13.0046 2.17709 12.2016 2.17709 11.0834C2.17709 9.96514 2.17755 9.16216 2.22905 8.53191C2.27998 7.90855 2.37785 7.5066 2.54381 7.18088C2.86638 6.5478 3.3811 6.03309 4.01419 5.71051Z"
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const FavoritesIcon = props => {
  return (
    <svg
      viewBox="0 0 17 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      stroke="black"
    >
      <path
        d="M8.49999 13.875L7.47291 12.9578C3.82499 9.71301 1.41666 7.57296 1.41666 4.94653C1.41666 2.80647 3.13082 1.125 5.31249 1.125C6.54499 1.125 7.72791 1.68781 8.49999 2.57718C9.27207 1.68781 10.455 1.125 11.6875 1.125C13.8692 1.125 15.5833 2.80647 15.5833 4.94653C15.5833 7.57296 13.175 9.71301 9.52707 12.9648L8.49999 13.875Z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
export const ProfileSettingsIcon = props => {
  return (
    <svg
      viewBox="0 0 14 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      stroke="black"
    >
      <path
        d="M12.4167 16.25H9.08334"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.75 17.9166V14.5833"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.13335 9.05829C7.05001 9.04996 6.95001 9.04996 6.85835 9.05829C4.87499 8.99163 3.29999 7.36663 3.29999 5.36663C3.29166 3.32496 4.94999 1.66663 6.99168 1.66663C9.03335 1.66663 10.6917 3.32496 10.6917 5.36663C10.6917 7.36663 9.10835 8.99163 7.13335 9.05829Z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.99167 18.1751C5.475 18.1751 3.9667 17.7917 2.8167 17.0251C0.800033 15.6751 0.800033 13.4751 2.8167 12.1334C5.10837 10.6001 8.86667 10.6001 11.1583 12.1334"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
export const AccountSettingsIcon = props => {
  return (
    <svg
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      stroke="black"
    >
      <path
        d="M9.5 12.125C10.9497 12.125 12.125 10.9497 12.125 9.5C12.125 8.05025 10.9497 6.875 9.5 6.875C8.05025 6.875 6.875 8.05025 6.875 9.5C6.875 10.9497 8.05025 12.125 9.5 12.125Z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.20357 8.3093C2.61705 8.56909 2.88309 9.01166 2.88309 9.49991C2.88308 9.98825 2.61704 10.4308 2.20357 10.6906C1.9222 10.8674 1.74092 11.0087 1.61194 11.1768C1.3294 11.545 1.2047 12.0104 1.26529 12.4705C1.31072 12.8156 1.51456 13.1687 1.92226 13.8749C2.32997 14.581 2.53382 14.9341 2.80998 15.146C3.17819 15.4286 3.64357 15.5533 4.10373 15.4927C4.31376 15.4651 4.52674 15.3787 4.82046 15.2235C5.25226 14.9953 5.76863 14.9862 6.19158 15.2304C6.61448 15.4746 6.86473 15.9263 6.88298 16.4143C6.8954 16.7463 6.92713 16.974 7.00821 17.1697C7.18582 17.5985 7.52651 17.9392 7.95527 18.1168C8.27692 18.25 8.68458 18.25 9.5 18.25C10.3154 18.25 10.7231 18.25 11.0447 18.1168C11.4735 17.9392 11.8142 17.5985 11.9918 17.1697C12.0728 16.974 12.1046 16.7463 12.117 16.4143C12.1352 15.9263 12.3855 15.4746 12.8085 15.2304C13.2313 14.9862 13.7477 14.9954 14.1794 15.2236C14.4732 15.3788 14.6862 15.4651 14.8962 15.4928C15.3564 15.5534 15.8218 15.4286 16.19 15.1461C16.4661 14.9343 16.67 14.5811 17.0778 13.875C17.2592 13.5606 17.4004 13.3162 17.505 13.1113M16.7964 10.6907C16.3829 10.4309 16.1169 9.98834 16.1168 9.50009C16.1168 9.01175 16.3829 8.56909 16.7964 8.3093C17.0778 8.13255 17.259 7.99124 17.3879 7.82315C17.6705 7.45493 17.7952 6.98955 17.7346 6.52939C17.6892 6.18427 17.4853 5.8312 17.0776 5.12504C16.6699 4.41888 16.466 4.06581 16.1899 3.8539C15.8217 3.57136 15.3563 3.44666 14.8961 3.50724C14.6861 3.5349 14.4731 3.62122 14.1794 3.77648C13.7476 4.00468 13.2313 4.01379 12.8084 3.76959C12.3855 3.52541 12.1352 3.07374 12.117 2.58578C12.1046 2.25371 12.0728 2.02606 11.9918 1.8303C11.8142 1.40151 11.4735 1.06083 11.0447 0.88321C10.7231 0.75 10.3154 0.75 9.5 0.75C8.68458 0.75 8.27692 0.75 7.95527 0.88321C7.52651 1.06083 7.18582 1.40151 7.00821 1.8303C6.92713 2.02604 6.8954 2.25367 6.88298 2.5857C6.86472 3.0737 6.61447 3.52542 6.19154 3.76959C5.76862 4.01377 5.25229 4.00464 4.82054 3.77645C4.52679 3.62119 4.31379 3.53485 4.10374 3.5072C3.64358 3.44662 3.1782 3.57131 2.80998 3.85386C2.53383 4.06577 2.32998 4.41885 1.92227 5.125C1.74077 5.43938 1.59967 5.68377 1.49496 5.88864"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export const BusinessIcon = props => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="none" d="M0 0h24v24H0V0z"></path>
      <path d="M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zM4 9h16v5h-5v-3H9v3H4V9zm9 6h-2v-2h2v2zm6 4H5v-3h4v1h6v-1h4v3z"></path>
    </svg>
    // <svg
    //   viewBox="0 0 24 24"
    //   xmlns="http://www.w3.org/2000/svg"
    //   {...props}
    //   fill="none"
    //   stroke="black"
    // >
    //   {/* The building (business) icon */}
    //   <rect
    //     x="3"
    //     y="8"
    //     width="18"
    //     height="12"
    //     rx="2"
    //     strokeWidth={1.5}
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   {/* Windows */}
    //   <rect
    //     x="6"
    //     y="11"
    //     width="3"
    //     height="3"
    //     strokeWidth={1.5}
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <rect
    //     x="10"
    //     y="11"
    //     width="3"
    //     height="3"
    //     strokeWidth={1.5}
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <rect
    //     x="14"
    //     y="11"
    //     width="3"
    //     height="3"
    //     strokeWidth={1.5}
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   {/* Door */}
    //   <rect
    //     x="9"
    //     y="15"
    //     width="6"
    //     height="5"
    //     strokeWidth={1.5}
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   {/* Roof of the building */}
    //   <path d="M1 8L12 3L23 8" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    // </svg>
  );
};
